var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _g3, _path12, _g4, _path13, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15900_130253)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#F6F7F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15900_130253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15900_130253)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#F6F7F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15900_130253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15900_130253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.6723 23.833H26.3203C23.5589 23.833 21.3203 26.0716 21.3203 28.833V119.181C21.3203 121.942 23.5589 124.181 26.3203 124.181H93.6723C96.4337 124.181 98.6723 121.942 98.6723 119.181V28.833C98.6723 26.0716 96.4337 23.833 93.6723 23.833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6723 23.833H26.3203C23.5589 23.833 21.3203 26.0716 21.3203 28.833V119.181C21.3203 121.942 23.5589 124.181 26.3203 124.181H93.6723C96.4337 124.181 98.6723 121.942 98.6723 119.181V28.833C98.6723 26.0716 96.4337 23.833 93.6723 23.833Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15900_130253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15900_130253)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2826 40.9753C36.5917 40.9753 38.4636 39.1034 38.4636 36.7943C38.4636 34.4852 36.5917 32.6133 34.2826 32.6133C31.9735 32.6133 30.1016 34.4852 30.1016 36.7943C30.1016 39.1034 31.9735 40.9753 34.2826 40.9753Z",
    fill: "#E6EBF6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1774 35.54H46.1974C45.3894 35.54 44.7344 36.195 44.7344 37.003V37.004C44.7344 37.812 45.3894 38.467 46.1974 38.467H64.1774C64.9854 38.467 65.6404 37.812 65.6404 37.004V37.003C65.6404 36.195 64.9854 35.54 64.1774 35.54Z",
    fill: "#E6EBF6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9211 35.958H73.3771C72.5691 35.958 71.9141 36.613 71.9141 37.421V37.422C71.9141 38.23 72.5691 38.885 73.3771 38.885H85.9211C86.7291 38.885 87.3841 38.23 87.3841 37.422V37.421C87.3841 36.613 86.7291 35.958 85.9211 35.958Z",
    fill: "#E6EBF6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3125 46.6201H87.5945",
    stroke: "#E5E5E5",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_15900_130253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_15900_130253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2826 60.2087C36.5917 60.2087 38.4636 58.3368 38.4636 56.0277C38.4636 53.7186 36.5917 51.8467 34.2826 51.8467C31.9735 51.8467 30.1016 53.7186 30.1016 56.0277C30.1016 58.3368 31.9735 60.2087 34.2826 60.2087Z",
    fill: "#E6EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1774 54.7734H46.1974C45.3894 54.7734 44.7344 55.4284 44.7344 56.2364V56.2374C44.7344 57.0454 45.3894 57.7004 46.1974 57.7004H64.1774C64.9854 57.7004 65.6404 57.0454 65.6404 56.2374V56.2364C65.6404 55.4284 64.9854 54.7734 64.1774 54.7734Z",
    fill: "#E6EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9211 55.1914H73.3771C72.5691 55.1914 71.9141 55.8464 71.9141 56.6544V56.6554C71.9141 57.4634 72.5691 58.1184 73.3771 58.1184H85.9211C86.7291 58.1184 87.3841 57.4634 87.3841 56.6554V56.6544C87.3841 55.8464 86.7291 55.1914 85.9211 55.1914Z",
    fill: "#E6EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3125 65.8535H87.5945",
    stroke: "#E5E5E5",
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_15900_130253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_15900_130253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2826 79.4421C36.5917 79.4421 38.4636 77.5702 38.4636 75.2611C38.4636 72.952 36.5917 71.0801 34.2826 71.0801C31.9735 71.0801 30.1016 72.952 30.1016 75.2611C30.1016 77.5702 31.9735 79.4421 34.2826 79.4421Z",
    fill: "#E6EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1774 74.0068H46.1974C45.3894 74.0068 44.7344 74.6618 44.7344 75.4698V75.4708C44.7344 76.2788 45.3894 76.9338 46.1974 76.9338H64.1774C64.9854 76.9338 65.6404 76.2788 65.6404 75.4708V75.4698C65.6404 74.6618 64.9854 74.0068 64.1774 74.0068Z",
    fill: "#E6EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9211 74.4248H73.3771C72.5691 74.4248 71.9141 75.0798 71.9141 75.8878V75.8888C71.9141 76.6968 72.5691 77.3518 73.3771 77.3518H85.9211C86.7291 77.3518 87.3841 76.6968 87.3841 75.8888V75.8878C87.3841 75.0798 86.7291 74.4248 85.9211 74.4248Z",
    fill: "#E6EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3125 85.0869H87.5945",
    stroke: "#E5E5E5",
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_15900_130253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_15900_130253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2826 98.6765C36.5917 98.6765 38.4636 96.8046 38.4636 94.4955C38.4636 92.1864 36.5917 90.3145 34.2826 90.3145C31.9735 90.3145 30.1016 92.1864 30.1016 94.4955C30.1016 96.8046 31.9735 98.6765 34.2826 98.6765Z",
    fill: "#E6EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1774 93.2412H46.1974C45.3894 93.2412 44.7344 93.8962 44.7344 94.7042V94.7052C44.7344 95.5132 45.3894 96.1682 46.1974 96.1682H64.1774C64.9854 96.1682 65.6404 95.5132 65.6404 94.7052V94.7042C65.6404 93.8962 64.9854 93.2412 64.1774 93.2412Z",
    fill: "#E6EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9211 93.6592H73.3771C72.5691 93.6592 71.9141 94.3142 71.9141 95.1222V95.1232C71.9141 95.9312 72.5691 96.5862 73.3771 96.5862H85.9211C86.7291 96.5862 87.3841 95.9312 87.3841 95.1232V95.1222C87.3841 94.3142 86.7291 93.6592 85.9211 93.6592Z",
    fill: "#E6EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3125 104.321H87.5945",
    stroke: "#E5E5E5",
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_15900_130253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_15900_130253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.6723 23.833H26.3203C23.5589 23.833 21.3203 26.0716 21.3203 28.833V119.181C21.3203 121.942 23.5589 124.181 26.3203 124.181H93.6723C96.4337 124.181 98.6723 121.942 98.6723 119.181V28.833C98.6723 26.0716 96.4337 23.833 93.6723 23.833Z",
    fill: "url(#paint0_linear_15900_130253)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15900_130253",
    x1: 59.9963,
    y1: 74.007,
    x2: 59.9963,
    y2: 103.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15900_130253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/emptyState.4d7b77b50320c66bb3bb765846867bca.svg";
export { ForwardRef as ReactComponent };